import { end, formatRoute, lit, url } from '/imports/modules/Routing';
import { messagesSectionQuery } from '/imports/ui/pages/myCourses/messages/navigation';
import { securitySectionQuery } from '/imports/ui/pages/user/security/navigation';

const userSlug = 'user';

const base = lit(userSlug);

export const pageKeys = {
  profile: null,
  messages: null,
  notifications: null,
  zoom: null,
  backup: null,
  security: null,
};

export type Page = keyof typeof pageKeys;
const page = (p: Page) => url(base, lit(p));

export const userRoute = url(base, end);
export const profileRoute = url(page('profile'), end);
export const messagesRoute = url(page('messages'), messagesSectionQuery, end);
export const notificationsRoute = url(page('notifications'), end);
export const securityRoute = url(page('security'), securitySectionQuery, end);
export const zoomRoute = url(page('zoom'), end);
export const backupRoute = url(page('backup'), end);

export const profileLink = formatRoute(profileRoute);
export const messagesLink = formatRoute(messagesRoute);
export const notificationsLink = formatRoute(notificationsRoute);
export const securityLink = formatRoute(securityRoute);
export const zoomLink = formatRoute(zoomRoute);
export const backupLink = formatRoute(backupRoute);

// Default route for user
export const userLink = profileLink;
